import React from "react";
import Div from "lib/Div";
import P from "lib/P";
import Btn from "components/Btn";
import arrow from "assets/img/icons/arrow.svg";
import {Image} from "react-native";

type Props = { text: string, onNext: () => void, buttonText: string, target: string };

const FullScreenTooltip = (props: Props) => {
  const {text, buttonText, target} = props;

  const tooltipPosition = (() => {
    if (target === 'wallet') return {top: 141, right: 16};
    if (target === 'shotAmount') return {top: 199, right: 16};
    if (target === 'payout') return {top: 445, right: 31.5};

    return {};
  })();

  return (
    <Div position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(0,0,0,0.4)" zIndex={9999}>
      <Div position="absolute" {...tooltipPosition} bg="#3369FF" p={16} rounded={8} w={280}>
        <Image source={arrow as any} style={{position: 'absolute', top: -20, right: 24, width: 16, height: 20}}/>
        <P fontFamily="DavisSans-Regular" mb={16}>{text}</P>

        <Div alignItems="flex-end">
          <Btn w={70} h={30} bg="#193B99" rounded={2} onPress={props.onNext} justifyContent="center">
            <P fontFamily="DavisSans-Medium" fs={14} ta="center">{buttonText}</P>
          </Btn>
        </Div>
      </Div>
    </Div>
  );
};

export default React.memo(FullScreenTooltip);
